import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { WfmNotificationListDto, WfmNotificationMutationDto, WfmNotificationReadAllDto, WfmNotificationState } from '@/app/core/models/wfm-notification.models';
import { buildApiUrl } from '@/app/features/WfmShared/utils/build-api-url';
import { StandardResponse } from '@/app/shared/models/api-response.model';
import { environment } from '@/environments/environment';

@Injectable({ providedIn: 'root' })
export class WfmNotificationApiService {
    private readonly http = inject(HttpClient);
    private readonly baseUrl = buildApiUrl(environment.ApiCore, 'v1.0/wfm-notifications');

    list(state: WfmNotificationState, page = 1, pageSize = 20): Observable<StandardResponse<WfmNotificationListDto>> {
        const params = new HttpParams().set('state', state).set('page', page).set('pageSize', pageSize);
        return this.http.get<StandardResponse<WfmNotificationListDto>>(this.baseUrl, { params });
    }

    markRead(notificationId: string): Observable<StandardResponse<WfmNotificationMutationDto>> {
        return this.http.patch<StandardResponse<WfmNotificationMutationDto>>(`${this.baseUrl}/${notificationId}/read`, null);
    }

    archive(notificationId: string): Observable<StandardResponse<WfmNotificationMutationDto>> {
        return this.http.patch<StandardResponse<WfmNotificationMutationDto>>(`${this.baseUrl}/${notificationId}/archive`, null);
    }

    markAllRead(): Observable<StandardResponse<WfmNotificationReadAllDto>> {
        return this.http.post<StandardResponse<WfmNotificationReadAllDto>>(`${this.baseUrl}/read-all`, null);
    }
}
